import * as URI from 'uri-js';
import { isEmail } from './String';

export default function prependProtocol(
  url: string,
  defaultScheme: string | undefined = 'https'
) {
  url = url.trim();

  const uri = URI.parse(url) as URI.URIComponents;

  // don't modify if the URL already has a scheme
  if (uri.scheme) {
    return url;
  }

  if (isEmail(url)) {
    const emailComponents: URI.MailtoURIComponents = {
      scheme: 'mailto',
      to: [url],
    };

    return URI.serialize(emailComponents);
  }

  return URI.serialize(
    URI.parse(url, {
      scheme: defaultScheme,
      reference: 'suffix',
    })
  );
}
